import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./Modal.css";
import { X } from "lucide-react";

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      className="Modal--Overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="Modal--Content" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="Modal--Close"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <X size={20} />
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
